export class DataFetchingError extends Error {
  constructor(message, extra) {
    super(message, {
      cause: extra.cause
    });
    this.extra = extra;
  }
}